var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveFolderUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1739_40369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1739_40369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.1153H12.75V12.6653L14.6096 14.525L15.6634 13.4711L12 9.8077L8.35578 13.4519L9.4096 14.5057L11.25 12.6653V17.1153ZM4.3077 20C3.80257 20 3.375 19.825 3.025 19.475C2.675 19.125 2.5 18.6974 2.5 18.1923V6.8077C2.5 6.30257 2.675 5.875 3.025 5.525C3.375 5.175 3.80257 5 4.3077 5H9.79803L11.798 7H19.6923C20.1974 7 20.625 7.175 20.975 7.525C21.325 7.875 21.5 8.30257 21.5 8.8077V18.1923C21.5 18.6974 21.325 19.125 20.975 19.475C20.625 19.825 20.1974 20 19.6923 20H4.3077ZM4.3077 18.5H19.6923C19.782 18.5 19.8557 18.4711 19.9134 18.4134C19.9711 18.3557 20 18.282 20 18.1923V8.8077C20 8.71795 19.9711 8.64422 19.9134 8.58652C19.8557 8.52883 19.782 8.49998 19.6923 8.49998H11.1846L9.1846 6.49998H4.3077C4.21795 6.49998 4.14423 6.52882 4.08653 6.58652C4.02883 6.64423 3.99998 6.71795 3.99998 6.8077V18.1923C3.99998 18.282 4.02883 18.3557 4.08653 18.4134C4.14423 18.4711 4.21795 18.5 4.3077 18.5Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveFolderUpload);
export default __webpack_public_path__ + "static/media/drive_folder_upload.6a6fe5ebbd37bf1b70d1c8931378f27c.svg";
export { ForwardRef as ReactComponent };